import PropTypes from "prop-types";
import React, { memo } from "react";
import { Button, Div } from "atomize";
import { motion } from "framer-motion";

PrimaryButton.defaultProps = {
    d: "flex",
    pos: "unset",
    justify: "unset",
    m: "auto",
    p: { x: "1rem" },
    bg: "transparent",
    textSize: "body",
    textColor: "text_alt",
    action: null,
    disabled: false,
    isLoading: false,
    zIndex: "unset",
    shadow: "",
    rounded: "20px",
};

function PrimaryButton({
    d,
    pos,
    right,
    justify,
    m,
    p,
    bg,
    textSize,
    textColor,
    action,
    text,
    disabled,
    isLoading,
    zIndex,
    shadow,
    id,
    style,
    rounded,
}) {
    return (
        <Div pos={pos} zIndex={zIndex} right={right}>
            <motion.div whileTap={{ scale: 0.95 }}>
                <Button
                    d={d}
                    justify={justify}
                    shadow={shadow}
                    m={m}
                    p={p}
                    h="3.5rem"
                    isLoading={isLoading}
                    bg={bg}
                    disabled={disabled}
                    w="fit-content"
                    rounded={rounded}
                    textSize={textSize}
                    textColor={textColor}
                    onClick={action}
                    style={{ ...style, whiteSpace: "nowrap" }}
                    id={id}>
                    {text}
                </Button>
            </motion.div>
        </Div>
    );
}

export default memo(PrimaryButton);
